import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { USAStates } from 'src/app/course/tests/enum/usa-states.enum';
import { YeFaqModalComponent } from './faq-modal/ye-faq-modal.component';
import { YoungEaglesService } from 'src/app/services/young-eagles.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-young-eagles-voucher-redeemption',
  templateUrl: './young-eagles-voucher-redeemption.component.html',
  styleUrls: ['./young-eagles-voucher-redeemption.component.scss']
})
export class YoungEaglesVoucherRedeemptionComponent implements OnInit {

  verifyForm: FormGroup;
  redeemForm: FormGroup;
  voucher: any = {
    businessName: '',
    name: '',
    email: '',
    phone: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    redeem: '',
    user: ''
  };
  states: { name: string, initials: string }[] = [];
  alert: any;
  loading: boolean = false;
  currentYear = new Date().getFullYear();
  verifyAttempted: boolean = false;
  redeemedVoucher: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private youngEaglesService: YoungEaglesService
  ) { }

  ngOnInit(): void {
    this.verifyForm = this.fb.group({
      code: ['', Validators.required]
    });

    this.redeemForm = this.fb.group({
      businessName: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      address: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip: ['', Validators.required]
    });

    this.states = Object.keys(USAStates).map(key => ({
      name: key.replace(/_/g, ' '),
      initials: USAStates[key as keyof typeof USAStates]
    }));

  }

  verifyVoucher(): void {
    if (this.verifyForm.invalid) {
      return;
    }

    this.loading = true;
    this.youngEaglesService.verifyVoucher(this.verifyForm.value.code).subscribe({
      next: (data) => {
        this.voucher = data;
        this.verifyAttempted = true;
        this.loading = false;
      },
      error: (error) => {
        this.verifyAttempted = true;
        if (error.error.status == 404) {
          this.alert = "The code you entered is not valid. Please check your voucher code and try again.";
        } else {
          this.alert = error.error.detail;
        }
        this.loading = false;
      }
    });
  }

  redeem(): void {
    if (this.redeemForm.invalid) {
      return;
    }

    this.loading = true;

    this.youngEaglesService.redeemVoucher(this.voucher.id, this.redeemForm.value).subscribe({
      next: (data) => {
        this.redeemedVoucher = true;
        this.voucher.redeemed = data.redeemed;
        this.loading = false;
      },
      error: (error) => {
        alert('Error redeeming voucher: ' + error);
        this.loading = false;
      }
    });
  }

  openFAQ(): void {
    const initialState = {};

    this.modalService.show(YeFaqModalComponent, {
      initialState,
      class: 'modal-lg rounded-modal'
    });
  }

}
